<template>
  <div class="forum-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="forum-sidebar" shadow="hover">
          <div slot="header" class="clearfix">
            <span class="header-title">论坛分类</span>
          </div>
          <div class="category-list">
            <div
              v-for="category in categories"
              :key="category.id"
              class="category-item"
              :class="{ active: currentCategoryId === category.id }"
              @click="handleCategoryClick(category.id)"
            >
              <i class="el-icon-document"></i>
              <span>{{ category.name }}</span>
            </div>
          </div>
          <div class="post-btn-container">
            <el-button type="primary" class="post-btn" @click="$router.push('/forum/post')">
              <i class="el-icon-edit"></i>
              发布帖子
            </el-button>
          </div>
        </el-card>

        <el-card class="forum-sidebar forum-stats" shadow="hover" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span class="header-title">论坛统计</span>
          </div>
          <div class="stats-content">
            <div class="stat-item">
              <div class="stat-number">1000+</div>
              <div class="stat-label">帖子总数</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">500+</div>
              <div class="stat-label">会员总数</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">100+</div>
              <div class="stat-label">今日发帖</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">20+</div>
              <div class="stat-label">今日在线</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card class="forum-main" shadow="hover">
          <div slot="header" class="clearfix">
            <span class="header-title">帖子列表</span>
            <div class="search-container">
              <el-input
                placeholder="请输入搜索内容"
                v-model="searchKeyword"
                class="search-input"
                @keyup.enter.native="handleSearch"
                clearable
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch" type="primary"></el-button>
              </el-input>
            </div>
          </div>
          <div class="post-list">
            <el-table :data="posts" style="width: 100%" stripe highlight-current-row>
              <el-table-column prop="title" label="标题" min-width="350" align="left">
                <template slot-scope="scope">
                  <div class="post-title">
                    <el-tag v-if="scope.row.isTop === 1" type="danger" size="mini" effect="dark">置顶</el-tag>
                    <el-tag v-if="scope.row.isHot === 1" type="warning" size="mini" effect="dark">精华</el-tag>
                    <a class="post-title-link" @click="goToPostDetail(scope.row.id)">{{ scope.row.title }}</a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="username" label="作者" width="120" align="center"></el-table-column>
              <el-table-column prop="createTime" label="发布时间" width="180" align="center">
                <template slot-scope="scope">
                  {{ formatDateTime(scope.row.createTime) }}
                </template>
              </el-table-column>
              <el-table-column prop="viewCount" label="浏览" width="80" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini">{{ scope.row.viewCount }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="replyCount" label="回复" width="80" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" type="success">{{ scope.row.replyCount }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="goToPostDetail(scope.row.id)">查看</el-button>
                  <el-button v-if="isAdmin" type="warning" size="mini" @click="editPost(scope.row.id)">编辑</el-button>
                  <el-button v-if="isAdmin" type="danger" size="mini" @click="deletePost(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-container">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Forum',
  data() {
    return {
      categories: [
        { id: 0, name: '全部' },
        { id: 1, name: '游戏讨论' },
        { id: 2, name: '约战大厅' },
        { id: 3, name: '战术分享' },
        { id: 4, name: '地图更新' },
        { id: 5, name: '投诉建议' }
      ],
      posts: [
        { id: 1, title: '澄海3C最新版本更新内容', username: 'admin', createTime: '2024-01-01', viewCount: 100, replyCount: 20, isTop: 1, isHot: 1, categoryId: 4 },
        { id: 2, title: '1v1约战技巧分享', username: 'player1', createTime: '2024-01-02', viewCount: 80, replyCount: 15, isTop: 0, isHot: 1, categoryId: 3 },
        { id: 3, title: '如何提高APM？', username: 'player2', createTime: '2024-01-03', viewCount: 60, replyCount: 10, isTop: 0, isHot: 0, categoryId: 1 },
        { id: 4, title: '寻找3v3队友', username: 'player3', createTime: '2024-01-04', viewCount: 40, replyCount: 5, isTop: 0, isHot: 0, categoryId: 2 },
        { id: 5, title: '关于游戏卡顿的问题', username: 'player4', createTime: '2024-01-05', viewCount: 30, replyCount: 3, isTop: 0, isHot: 0, categoryId: 1 }
      ],
      currentCategoryId: 0,
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      total: 5,
      isAdmin: false
    }
  },
  created() {
    this.fetchCategories()
    this.fetchPosts()
    this.checkAdminStatus()
  },
  methods: {
    fetchCategories() {
      this.$axios.get('/forum/category/list').then(res => {
        this.categories = [{ id: 0, name: '全部' }, ...res.data]
      })
    },
    fetchPosts() {
      this.$axios.get('/forum/post/list', {
        params: {
          categoryId: this.currentCategoryId === 0 ? null : this.currentCategoryId
        }
      }).then(res => {
        this.posts = res.data
        this.total = res.data.length
      })
    },
    handleCategoryClick(categoryId) {
      this.currentCategoryId = categoryId
      this.currentPage = 1
      this.fetchPosts()
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchPosts()
    },
    goToPostDetail(id) {
      this.$router.push(`/forum/detail/${id}`)
    },
    editPost(id) {
      this.$router.push(`/forum/post/${id}`)
    },
    deletePost(id) {
      this.$confirm('确定要删除这篇帖子吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`/forum/post/delete/${id}`).then(res => {
          this.$message.success('删除成功')
          this.fetchPosts()
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchPosts()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchPosts()
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    checkAdminStatus() {
      // 这里可以检查用户是否为管理员
      // const role = localStorage.getItem('role')
      // this.isAdmin = role === 'admin'
      this.isAdmin = true // 测试用，实际应该从API获取
    }
  }
}
</script>

<style scoped>
.forum-container {
  padding: 0;
}

.forum-main,
.forum-sidebar {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.forum-main:hover,
.forum-sidebar:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
  transform: translateY(-2px);
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

/* 分类列表样式 */
.category-list {
  padding: 8px 0;
}

.category-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin-bottom: 4px;
  font-size: 14px;
}

.category-item:hover {
  background-color: #f0f9ff;
  color: #1890ff;
  transform: translateX(5px);
}

.category-item.active {
  background-color: #1890ff;
  color: white;
  font-weight: 500;
  transform: translateX(5px);
}

.category-item i {
  margin-right: 8px;
  font-size: 14px;
}

/* 发布按钮样式 */
.post-btn-container {
  padding: 15px 0 10px 0;
  text-align: center;
}

.post-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.post-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

/* 搜索框样式 */
.search-container {
  display: flex;
  justify-content: flex-end;
}

.search-input {
  width: 280px;
  border-radius: 20px;
  overflow: hidden;
}

.search-input .el-input__inner {
  border-radius: 20px 0 0 20px;
}

.search-input .el-input__append button {
  border-radius: 0 20px 20px 0;
}

/* 帖子列表样式 */
.post-list {
  padding: 10px 0;
}

.post-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.post-title-link {
  color: #303133;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  line-height: 1.5;
}

.post-title-link:hover {
  color: #1890ff;
  text-decoration: underline;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 论坛统计样式 */
.forum-stats {
  padding: 10px 0;
}

.stats-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  padding: 10px 0;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background-color: #fafafa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.stat-item:hover {
  background-color: #f0f9ff;
  transform: translateY(-2px);
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 12px;
  color: #606266;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .el-col {
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .search-input {
    width: 100%;
    margin-top: 10px;
  }
  
  .search-container {
    justify-content: center;
  }
  
  .stats-content {
    grid-template-columns: 1fr;
  }
}
</style>